import React from 'react';
import { Helmet } from 'react-helmet';
import PmHome from '../components/pm/PmHome';
import { BUSINESS } from '../data/pmContent';

const TITLE = `${BUSINESS.name} | Microblading, cejas, pestañas y maquillaje en Santo Domingo`;
const DESCRIPTION = 'Estudio de belleza en Los Prados, Santo Domingo. Maquillaje semipermanente, microblading, cejas, pestañas, uñas, peluquería y cuidado de la piel. Agenda tu cita online.';

const HomePage = () => (
    <div className="pm-scope">
        <Helmet>
            <title>{TITLE}</title>
            <meta name="description" content={DESCRIPTION} />
            <meta property="og:title" content={TITLE} />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="/" />
            <meta property="og:site_name" content={BUSINESS.name} />
            <meta property="og:description" content={DESCRIPTION} />
        </Helmet>
        <PmHome />
    </div>
);

export default HomePage;
